import _ from 'lodash'
import * as moment from 'moment'
import { equals, toLower } from 'ramda'

import { MAX_USER_LAST_ACTIVE_TIME } from 'constants/UserConstants'

const encodeQueryData = function (data) {
  const ret = []
  for (const key in data) {
    const value = data[key]
    if (_.isArray(value)) {
      _.each(value, (element) =>
        ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(element)}`)
      )
    } else if (value !== null) {
      ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    }
  }
  return ret.join('&')
}

export const similarNameOrEmail = ({ name, email }, value) => {
  return (
    (name && toLower(name).includes(toLower(value))) ||
    (email && toLower(email).includes(toLower(value)))
  )
}

export { encodeQueryData }

export const resolveLastActiveDate = (timestamp) => {
  if (!timestamp) {
    return MAX_USER_LAST_ACTIVE_TIME
  }
  if (equals('N/A', timestamp)) {
    return timestamp
  }

  const momentTimestamp = moment(new Date(timestamp), 'YYYYMMDD').fromNow()
  if (momentTimestamp.includes('year')) {
    return MAX_USER_LAST_ACTIVE_TIME
  }
  if (
    momentTimestamp.includes('minutes') ||
    momentTimestamp.includes('seconds')
  ) {
    return '< 1 hour ago'
  }
  return momentTimestamp
}

// function to assign value to deep path of object
export function setValueToPath(obj, value, path) {
  const arrPath = typeof path === 'string' ? path.split('.') : path

  let newObj
  for (let i = arrPath.length - 1; i >= 0; i--) {
    if (i === arrPath.length - 1) {
      newObj = { [arrPath[i]]: value }
    } else {
      newObj = { [arrPath[i]]: { ...obj[[arrPath[i]]], ...newObj } }
    }
  }
  return { ...obj, ...newObj }
}
